import { Component, OnInit, Input, effect, inject } from '@angular/core';
import { EnvService } from 'src/app/env.service';
import { SharedSignalsService } from '../../services/shared-signals.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { TranslationService } from '../../services/translation.service';
import { SessionVariable } from '../../enum/session-variable';
@Component({
    selector: 'taly-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  transferSignal = inject(SharedSignalsService);
  toggleCurrentLanguage: boolean = false;
  currentYear: number;
  osInfo:any;
  appIcon:any;
  appLink:any;

  socialMedia:any = [] = [
    {
      name : 'LinkedIn',
      icon : "assets/images/LinkedIn-icon.svg",
      url : "https://www.linkedin.com/company/taly-io/"
    },
    {
      name : 'Instagram',
      icon : "assets/images/instagram-icon.svg",
      url : "https://instagram.com/taly.io?igshid=NzZlODBkYWE4Ng=="
    },
    {
      name : 'Til-tok',
      icon : "assets/images/tik-tok.svg",
      url : "https://x.com/talypay?s=11&t=ZBvnn70MW0LgBkooUsryKg"
    },
    {
      name : 'Twiter',
      icon : "assets/images/twiter.svg",
      url : "https://twitter.com/"
    },
    
  ]

  paymentPartners : any[] = [
    {
      name : 'Lock',
      icon : 'assets/images/lock-icon.svg'
    },
    {
      name : 'Knet',
      icon : 'assets/images/knet-logo.svg'
    },
    {
      name : 'Master Card',
      icon : 'assets/images/master-card-logo.svg'
    },
    {
      name : 'Visa Card',
      icon : 'assets/images/footer-visa-icon.svg'
    },
    {
      name : 'Apple Pay',
      icon : 'assets/images/apple-icon.svg'
    },
 
  
    {
      name : 'Gpay',
      icon : "assets/images/gpay-icon.svg",
    }
  ]

  constructor(public envService : EnvService,private storageService : LocalStorageService,public translationService: TranslationService) {

    effect(() => {
      this.osInfo = this.transferSignal?.userAgentType();
     
      if(this.osInfo == 'iOS'){
        this.appIcon = 'assets/images/app-store-img.svg';
        this.appLink = envService.appIOSURL;
      }else{
        this.appIcon = 'assets/images/google-play-store.svg';
        this.appLink = envService.appAndroidURL;
      }

    })

    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
  }

  ngOnInit(): void {

  }
  toggleText() {    
    this.toggleCurrentLanguage = !this.toggleCurrentLanguage;
    const currentLanguage = this.toggleCurrentLanguage ? 'ar-KW' : 'en-US'
    this.transferSignal.setTextDirection(currentLanguage == 'ar-KW' ? 'rtl' : 'ltr');
    this.storageService.setItem(SessionVariable.LANGUAGE, currentLanguage);
    this.translationService.switchLanguage(currentLanguage);
  }
}
